import { useTranslation } from "./useTranslation.js";
function useIsBrazil() {
    const { countryCode } = useTranslation();
    return 'br' === countryCode;
}
export { useIsBrazil };
